<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'kgr-inputGroup--inline': inline }"
    >
        <div
            v-if="label !== null"
            class="kgr-inputGroup__label"
        >{{ label }}</div>
        <kgr-time-picker
            :value="start"
            :error-state="error"
            :disabled="disabled"
            inline
            @change="changeStart($event)"
            @error="timePickerStartError = true"
        />
        -
        <kgr-time-picker
            :value="end"
            :error-state="error"
            :disabled="disabled"
            inline
            @change="changeEnd($event)"
            @error="timePickerEndError = true"
        />
    </label>
</template>

<script>
import Time from '../../../../js/date/Time';
import TimePicker from './TimePicker.vue';
import TimeRange from '../../../../js/date/TimeRange';

export default {
    components: {
        'kgr-time-picker': TimePicker,
    },
    props: {
        start: {
            type: String,
            example: '09:30',
        },
        end: {
            type: String,
            example: '10:30',
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            startData: null,
            endData: null,
            error: false,
            timePickerStartError: false,
            timePickerEndError: false,
        }
    },
    computed: {
        hasErrors() {
            return this.error || this.timePickerStartError || this.timePickerEndError;
        },
    },
    watch: {
        hasErrors(hasError) {
            this.$emit('errorStateChanged', hasError);
        },
    },
    mounted() {
        try {
            this.startData = Time.fromString(this.start);
            this.endData = Time.fromString(this.end);
            this.error = false;
        } catch (error) {
            this.error = true;
        }
    },
    methods: {
        changeStart(time) {
            this.timePickerStartError = false;
            this.startData = time;
            this.change();
        },
        changeEnd(time) {
            this.timePickerEndError = false;
            this.endData = time;
            this.change();
        },
        change() {
            try {
                let range = new TimeRange(this.startData, this.endData);
                this.$emit('change', range);
                this.error = false;
            } catch (error) {
                this.error = true;
            }
        }
    }
}
</script>
